import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { sessionActions } from '../../../../../../store';

import type { Moment } from 'moment';

export function useBackdateSession(sessionId: string | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmBackdateDialog, setShowConfirmBackdateDialog] = useState(false);
  const [pendingBackdateDate, setPendingBackdateDate] = useState<Moment | null>(null);
  const [pendingBackdateUtcOffset, setPendingBackdateUtcOffset] = useState<number | null>(null);

  const requestBackdate = useCallback((backdatedDate: Moment, utcOffset: number | null) => {
    setPendingBackdateDate(backdatedDate);
    setPendingBackdateUtcOffset(utcOffset);
    setShowConfirmBackdateDialog(true);
  }, []);

  const handleBackdateSession = useCallback(async () => {
    if (!sessionId || !pendingBackdateDate) return;
    setShowConfirmBackdateDialog(false);

    const { error } = await dispatch(
      sessionActions.backdateSession({
        sessionId,
        data: {
          date_start: pendingBackdateDate,
          utc_offset_date_start: pendingBackdateUtcOffset ?? 0,
        },
        getAccessTokenSilently,
      }),
    );

    if (!error) {
      location.reload();
    }
  }, [dispatch, getAccessTokenSilently, sessionId, pendingBackdateDate, pendingBackdateUtcOffset]);

  return {
    showConfirmBackdateDialog,
    setShowConfirmBackdateDialog,
    requestBackdate,
    handleBackdateSession,
  };
}
